module.exports = __webpack_public_path__ + "static/media/GrammerFlip_TutorialSplash.8c1d9646.png";